// SMO Lead Raporları sayfası ve pencereleri. Excel dosyaları ve kayıtlara
// yazılan değerler Türkçe kalır; burada yalnızca ekrandaki metinler var.
const smoLead = {
  title: 'SMO Lead Raporları',
  breadcrumb: 'Raporlar / SMO Lead Raporları',

  header: {
    manualEntry: 'Manuel Veri Girişi',
    refresh: 'Yenile',
    refreshing: 'Yenileniyor...',
    refreshHint: 'Çalışan verilerini yenile',
    download: 'Tabloyu İndir',
    downloadHint: 'Filtrelenmiş çalışan tablosunu Excel olarak indir',
  },

  stats: {
    totalSmo: 'Toplam SMO Sayısı',
    centers: 'SMO’ya Bağlı Merkez Sayısı',
    workers: 'Bu SMO Altında Çalışan Sayısı',
    centerSplit: '({{primer}} Primer, {{backup}} Backup)',
  },

  picker: {
    title: 'SMO Listesi',
    subtitle: 'Detayları görmek için bir SMO seçiniz',
    loading: 'SMO listesi yükleniyor...',
    empty: 'Henüz hiçbir merkeze SMO atanmamış.',
    backup: 'Yedek',
    centerBackup: 'Merkez Yedeği',
    project: 'Proje',
    centers_one: '{{count}} Merkez',
    centers_other: '{{count}} Merkez',
    projectBackupHint: 'Yedek görünümü: {{project}}',
    centerBackupHint_one: 'Merkez yedeği görünümü: {{count}} merkez',
    centerBackupHint_other: 'Merkez yedeği görünümü: {{count}} merkez',
    delegatedLegend: '“Yedek”: bir projede yedek SMO Lead olarak atandığınız için yalnızca o projeyi görürsünüz. “Merkez Yedeği”: yedek SMO olduğunuz merkezlerle sınırlı görünüm.',
    toggleHint: 'Seçili SMO’ya tekrar tıklarsanız seçim kaldırılır.',
  },

  team: {
    title: '{{name}} - Çalışanlar',
    subtitle: 'Bu SMO’ya bağlı merkezlerde atanmış çalışanlar ve projeleri.',
    projectBackup: 'Yedek görünüm · {{project}}',
    projectBackupHint: 'Bu görünüm yedek SMO Lead atamanız nedeniyle yalnızca seçili proje ile sınırlıdır',
    centerBackup_one: 'Merkez yedeği görünümü · {{count}} merkez',
    centerBackup_other: 'Merkez yedeği görünümü · {{count}} merkez',
    centerBackupHint: 'Bu görünüm, yedek SMO olarak atandığınız merkezler ile sınırlıdır',
    removeSmo: 'SMO’yu Kaldır',
    removeSmoHint: 'Bu SMO atamasını merkezlerinden kaldır',
    loading: 'Çalışanlar yükleniyor...',
    noMatch: 'Arama kriterine uygun çalışan bulunamadı.',
    empty: 'Bu SMO altında çalışan bulunmamaktadır.',
    missingDocs_one: '{{count}} çalışanın eksik CV/GCP/IATA belgesi var. Kimlerin eksiği olduğunu görmek için çalışanın klasör simgesine dokunun.',
    missingDocs_other: '{{count}} çalışanın eksik CV/GCP/IATA belgesi var. Kimlerin eksiği olduğunu görmek için çalışanın klasör simgesine dokunun.',
  },

  centers: {
    unknownCity: 'Bilinmeyen İl',
    unknownDistrict: 'Bilinmeyen İlçe',
    cityCount_one: '{{count}} Merkez',
    cityCount_other: '{{count}} Merkez',
    cityCountDistricts_one: '{{count}} Merkez · {{districts}} İlçe',
    cityCountDistricts_other: '{{count}} Merkez · {{districts}} İlçe',
    districtCount_one: '{{count}} merkez',
    districtCount_other: '{{count}} merkez',
    primerHint: 'Bu merkezin primer SMO’su',
    backupHint: 'Bu merkezin yedek (backup) SMO’su',
    legendPrimer: 'Primer SMO',
    legendBackup: 'Backup (yedek) SMO',
    legendToggle: 'Merkezleri görmek için şehre dokunun; 10’dan fazla merkezi olan şehirler ilçelere ayrılır.',
  },

  filters: {
    search: 'Çalışan, proje veya merkez ara...',
    status: 'Durum',
    type: 'Tip',
    blinded: 'Kör Durumu',
    finished: 'Bitmiş Projeler',
    allCount: 'Tümü ({{count}})',
    allTypes: 'Tüm Tipler ({{count}})',
    active: 'Aktif',
    inactive: 'Pasif',
    incomplete: 'Tamamlanmamış',
    hideFinished: 'Bitmiş projeleri gizle',
    finishedHidden: 'Bitmiş projeler gizli',
    finishedHint: 'Bitmiş olarak işaretlenen projeleri listeden gizle',
    remove: 'Filtreyi kaldır',
    clearAll: 'Tümünü Temizle',
    help: 'Filtreler çalışanların proje atamalarına uygulanır; eşleşen ataması kalmayan çalışan listeden çıkar. “Tamamlanmamış” seçilince yalnızca bitirilmemiş vizit veya görevi olan çalışanlar listelenir ve satır açıldığında bu görevler gösterilir.',
  },

  table: {
    expand: 'Aç / kapat',
    worker: 'Çalışan',
    email: 'E-posta',
    phone: 'Telefon',
    projectCount: 'Proje Sayısı',
    centers: 'Merkez(ler)',
    documents: 'Belgeler',
    action: 'İşlem',
    removeWorker: 'Bu çalışanı bu SMO’dan çıkar',
    viewDocs: '{{name}} - CV/GCP/IATA belgelerini görüntüle',
    missingDocs: 'Eksik belge: {{list}}',
    incompleteVisits_one: '{{count}} tamamlanmamış vizit',
    incompleteVisits_other: '{{count}} tamamlanmamış vizit',
    rowHint: 'Satıra tıklayınca çalışanın projeleri açılır.',
    docsLegend: 'CV/GCP/IATA belgeleri (kırmızı sayı: eksik zorunlu belge)',
    incompleteLegend: 'Tamamlanmamış vizit sayısı',
    scrollLeft: 'Tabloyu sola kaydır',
    scrollRight: 'Tabloyu sağa kaydır',
    showProjects: 'Projeleri göster',
    hideProjects: 'Projeleri gizle',
    leave: 'İzin',
    leaveLegend: 'Bu yıl kalan yıllık izin; “İzinde”: bugün izinli',
    viewLeaves: '{{name}} - izin detayları',
    leaveRemaining: 'Bu yıl kalan yıllık izin: {{days}}',
    leavePending_one: '{{count}} talep onay bekliyor',
    leavePending_other: '{{count}} talep onay bekliyor',
    onLeave: 'İzinde',
  },

  projects: {
    finished: 'Bitti',
    role: 'Rol',
    center: 'Merkez',
    city: 'İl',
    type: 'Tip',
    blinded: 'Kör',
    rate: 'Tarife',
    assignedAt: 'Atanma Tarihi',
    viewVisits: 'Visitleri Görüntüle',
    incompleteHint_one: '{{count}} vizit tamamlanmadı',
    incompleteHint_other: '{{count}} vizit tamamlanmadı',
    help: '“Visitleri Görüntüle” çalışanın o projedeki vizitlerini açar; turuncu buton ve sayı tamamlanmamış vizit olduğunu gösterir.',
  },

  tasks: {
    title: 'Tamamlanmamış Görevler ({{count}})',
    dialogTitle: 'Tamamlanmamış Görevler',
    visit: 'Vizit',
    job: 'Görev',
    calendarJob: 'Takvim Görevi',
    patient: 'Hasta',
    homeVisit: 'Ev Viziti',
    siteVisit: 'Hastane Viziti',
    notDone: 'Tamamlanmadı',
    allDone: 'Harika! Tüm görevler tamamlanmış durumda.',
    summary: '{{total}} tamamlanmamış görev bulundu ({{visits}} vizit, {{jobs}} takvim görevi).',
    columns: {
      date: 'Tarih',
      worker: 'Çalışan',
      type: 'Görev Tipi',
      description: 'Açıklama',
      status: 'Durum',
    },
  },

  jobs: {
    view: 'İş Planlarını Görüntüle',
    hint: 'Çalışanın takvime yazdığı tüm işler, tamamlananlar dahil',
    title: 'İş Planları',
    loading: 'İş planları yükleniyor',
    empty: 'Bu çalışanın iş planı yok',
    emptyHint: 'Çalışan takvimine iş eklediğinde burada listelenir.',
    noMatch: 'Bu tarih aralığında iş planı yok',
    noMatchHint: 'Tarihleri değiştirin ya da temizleyin.',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    clearDates: 'Tarihleri temizle',
    total: 'Toplam İş: {{count}}',
    completed: '{{count}} tamamlandı',
    ongoing: '{{count}} devam ediyor',
    done: 'Tamamlandı',
    open: 'Devam Ediyor',
    columns: {
      date: 'Tarih',
      time: 'Saat',
      job: 'İş',
      project: 'Proje',
      status: 'Durum',
    },
  },

  section: {
    show: 'Göster',
    hide: 'Gizle',
    expand: 'Genişlet',
    collapse: 'Daralt',
    excelHint: 'Excel olarak indir',
    loading: 'Yükleniyor...',
    noVisits: 'Seçilen tarih aralığında vizit bulunamadı.',
  },

  dateRange: {
    label: 'Tarih Aralığı:',
    start: 'Başlangıç tarihi',
    end: 'Bitiş tarihi',
    thisMonth: 'Bu Ay',
    thisMonthHint: 'Ayın başından bugüne',
    all: 'Tümü',
    allHint: 'Tüm zamanlar',
    allRecorded: 'Tüm kayıtlı dönem',
    allActive: 'Tarih sınırı yok',
  },

  sections: {
    overview: {
      title: 'Operasyonel Genel Bakış',
      text: 'Seçilen dönemdeki tüm vizitlerin özeti: kalite, SLA, dokümantasyon ve kat edilen mesafe.',
      status: '{{total}} vizit analiz edildi ({{home}} ev / {{site}} hastane)',
    },
    quality: {
      title: 'Kalite & Klinik Risk Paneli',
      text: 'Protokol sapması, CAPA, Screen Fail, Drop Patient, AE/SAE ve DCF gibi kalite ve klinik risk göstergeleri.',
      status_one: '{{count}} vizit',
      status_other: '{{count}} vizit',
    },
    performance: {
      title: 'Ekip Performans Analizi',
      text: 'Saha koordinatörü bazında vizit sayısı, SLA, eCRF / kaynak doküman tamlığı, mesafe ve gecikmeler.',
      status_one: '{{count}} çalışan analiz edildi',
      status_other: '{{count}} çalışan analiz edildi',
    },
    noVisit: {
      title: 'Viziti Olmayan Çalışanlar',
      text: 'Seçilen dönemde viziti olmayan çalışanların takvime girdiği işler: kaç iş girildi, kaçı tamamlandı, son iş ne zaman.',
      status_one: '{{count}} çalışan',
      status_other: '{{count}} çalışan',
    },
    activity: {
      title: 'Ekip Sistem Kullanımı',
      text: 'Şu an kimin çevrimiçi olduğu ve ekibin sistemde geçirdiği süre, giriş sayıları.',
      status: '{{online}} / {{total}} çevrimiçi',
    },
    training: {
      title: 'Eğitim ve SOP Takibi',
      text: 'Ekipte kendisine atanan SOP ve eğitimleri henüz tamamlamamış çalışanlar.',
      pending_one: '{{count}} çalışan tamamlamadı',
      pending_other: '{{count}} çalışan tamamlamadı',
      overdue_one: '{{count}} gecikmiş',
      overdue_other: '{{count}} gecikmiş',
      allDone: 'Tüm ekip tamamladı',
    },
  },

  common: {
    detailHint: 'Detayları görüntülemek için tıklayın',
    days: '{{value}} gün',
  },

  overview: {
    clickHint: 'Büyüteç işaretli kutulara ve uyarılara tıklayarak ilgili vizitlerin ayrıntısını (kim, ne zaman, ne oldu) açabilirsiniz.',
    totalVisits: 'Toplam Vizit',
    homeSite: '{{home}} ev · {{site}} hastane',
    qualityRate: 'Sorunsuz Vizit Oranı',
    issueVisits_one: '{{count}} sorunlu vizit',
    issueVisits_other: '{{count}} sorunlu vizit',
    issueHint: 'Sorunlu vizitleri görüntüleyin',
    slaRate: 'SLA Karşılanma',
    overdueVisits_one: '{{count}} gecikmiş vizit',
    overdueVisits_other: '{{count}} gecikmiş vizit',
    overdueHint: 'Gecikmiş vizitleri görüntüleyin',
    docRate: 'Dokümantasyon Tamlığı',
    docSub: 'eCRF + Kaynak + İmza ortalaması',
    totalKm: 'Toplam KM',
    kmSub: 'Seyahat edilen mesafe',
    comparison: 'Ev vs Hastane Karşılaştırması',
    cycle: 'Döngü Süreleri & Süreç Özeti',
    cycleHome: 'Ort. Döngü — Ev',
    cycleSite: 'Ort. Döngü — Hastane',
    missingProcessEnd: 'Süreç Bitiş Tarihi Eksik',
    missed: 'Kaçırılan Vizit',
    cycleHelp: 'Döngü süresi: vizit tarihinden süreç bitiş tarihine kadar geçen gün. Süreç bitiş tarihi girilmemiş vizitler bu ortalamaya katılmaz.',
    monthlyTrend: 'Aylık Vizit Trendi',
    qualityPie: 'Vizit Kalite Dağılımı',
    coordinatorTable: 'Koordinatör Bazlı Ev Viziti Dağılımı',
  },

  alerts: {
    overdue: 'SLA karşılanma oranı %{{rate}} — hedefin altında',
    issues: 'Sorun oranı %{{rate}} — yüksek seviyede',
    deviation: 'Protokol sapma oranı %{{rate}}',
    missingProcessEnd_one: '{{count}} vizitte süreç bitiş tarihi eksik',
    missingProcessEnd_other: '{{count}} vizitte süreç bitiş tarihi eksik',
    missed_one: '{{count}} vizit kaçırıldı',
    missed_other: '{{count}} vizit kaçırıldı',
    aesae_one: '{{count}} AE/SAE rapor edildi',
    aesae_other: '{{count}} AE/SAE rapor edildi',
  },

  issue: {
    issues: 'Sorunlu Vizitler',
    overdue: 'SLA Gecikmiş Vizitler',
    missingProcessEnd: 'Süreç Bitiş Tarihi Eksik Vizitler',
    missed: 'Kaçırılan Vizitler',
    personIssues: '{{name}} — Sorunlar',
    personMissed: '{{name}} — Kaçırılan',
    personIssueDeviation: '{{name}} — Sorun & Sapma',
    personOverdue: '{{name}} — Gecikmiş Vizitler',
  },

  coordinators: {
    coordinator: 'Koordinatör',
    homeVisits: 'Ev Viziti',
    issues: 'Sorun',
    missed: 'Kaçırılan',
    aesae: 'AE/SAE',
    dcf: 'DCF',
    issueRate: 'Sorun Oranı',
    total: 'TOPLAM',
  },

  metrics: {
    deviation: 'Protokol Sapması',
    capa: 'CAPA Açılan',
    screenFail: 'Screen Fail',
    dropPatient: 'Drop Patient',
    aesae: 'AE/SAE',
    dcf: 'DCF',
  },

  quality: {
    clickHint: 'Sıfırdan büyük kutulara ve satırlara tıklayarak ilgili vizitleri görebilirsiniz.',
    inVisits_one: '{{name}} — {{count}} vizit içinde',
    inVisits_other: '{{name}} — {{count}} vizit içinde',
    safetyTitle: 'Hasta Güvenliği & Uyumluluk',
    siteTitle: 'Hastane Vizitleri — Hasta Durumu',
    aeSaeReported: 'AE/SAE Rapor Edilen',
    dcfCreated: 'DCF Oluşturulan',
    missedVisit: 'Kaçırılan Vizit',
    totalSite: 'Toplam Hastane Viziti',
    screenFail: 'Tarama Başarısız (Screen Fail)',
    dropPatient: 'Hasta Çıkışı (Drop Patient)',
    slaOverdue: 'SLA Gecikmiş',
    missingProcessEnd: 'Süreç Bitiş Tarihi Eksik',
    coordinatorChart: 'Koordinatör Bazlı Sorun Dağılımı',
    monthlyIssues: 'Aylık Sorun Trendi',
    chartsNote: 'Bu iki grafik ev vizitlerinden ve Operasyonel Genel Bakış’ın tarih aralığına göre hesaplanır.',
  },

  performance: {
    help: 'Altı çizili sayılara tıklayarak sorunlu ve gecikmiş vizitleri açabilirsiniz. “İstatistikler” çalışanın ayrıntılı istatistik sayfasını bu tarih aralığıyla açar.',
    stats: 'İstatistikler',
    statsHint: 'Detaylı İstatistikler',
    workload: 'İş Yükü Dağılımı (Vizit Sayısı)',
    kmPerEmployee: 'Çalışan Başına KM',
    slaHomeSite: 'Ev vs Hastane: SLA Karşılanma',
    columns: {
      coordinator: 'Saha Koordinatörü',
      visits: 'Vizit (Ev/Hastane)',
      sla: 'SLA %',
      ecrf: 'eCRF %',
      source: 'Kaynak %',
      issueDeviation: 'Sorun / Sapma',
      km: 'KM',
      overdue: 'Gecikme',
      actions: 'İşlemler',
    },
  },

  noVisit: {
    help: 'Seçilen dönemde viziti olan çalışanlar burada değil, Ekip Performans Analizi’nde görünür. Buradaki değerler takvim işlerinden hesaplanır; gecikmiş iş, başlangıç günü geçtiği halde tamamlanmamış iştir.',
    empty: 'Bu dönemde viziti olmayan çalışan yok.',
    noRecord: 'Kayıt yok',
    viewJobs: 'İş Planları',
    viewJobsHint: 'Çalışanın bu dönemdeki işlerini görüntüle',
    tiles: {
      workers: 'Çalışan',
      jobs: 'İş Girişi',
      done: 'Tamamlanma',
      overdue: 'Gecikmiş İş',
      noRecord: 'Kaydı Olmayan',
    },
    columns: {
      worker: 'Çalışan',
      role: 'Rol',
      jobs: 'İş Girişi',
      done: 'Tamamlanan',
      open: 'Devam Eden',
      overdue: 'Gecikmiş',
      donePct: 'Tamamlanma',
      activeDays: 'Aktif Gün',
      lastDay: 'Son İş',
      actions: 'İşlemler',
    },
  },

  chart: {
    home: 'Ev',
    visits: 'Vizit',
    site: 'Hastane',
    issues: 'Sorun',
    missed: 'Kaçırılan',
    homeVisit: 'Ev Viziti',
    siteVisit: 'Hastane Viziti',
    slaMet: 'SLA Karşılanma %',
    issueRate: 'Sorun Oranı (%)',
    slaCompliance: 'SLA Uyumu (%)',
    documentation: 'Dokümantasyon (%)',
    withIssue: 'Sorunlu Vizit',
    withoutIssue: 'Sorunsuz Vizit',
  },

  time: {
    hm: '{{h}} sa {{m}} dk',
    m: '{{m}} dk',
    s: '{{s}} sn',
    noActivity: 'Aktivite yok',
    justNow: 'Az önce',
    minutesAgo_one: '{{count}} dk önce',
    minutesAgo_other: '{{count}} dk önce',
    hoursAgo_one: '{{count}} saat önce',
    hoursAgo_other: '{{count}} saat önce',
    daysAgo_one: '{{count}} gün önce',
    daysAgo_other: '{{count}} gün önce',
  },

  deadline: {
    none: 'Son tarih belirtilmemiş',
    overdue_one: '{{count}} gün gecikti',
    overdue_other: '{{count}} gün gecikti',
    today: 'Bugün son gün',
    lastDay: 'Son 1 gün',
    left: '{{count}} gün kaldı',
  },

  activity: {
    loading: 'Kullanım verileri yükleniyor...',
    noWorkers: 'Bu SMO altında çalışan bulunamadı.',
    error: 'Kullanım geçmişi yüklenemedi.',
    online: 'Çevrimiçi',
    offline: 'Çevrimdışı',
    window: 'Kullanım geçmişi son {{days}} gün için tutulur ({{date}} tarihinden itibaren).',
    tiles: {
      online: 'Şu An Çevrimiçi',
      total: 'Ekip Toplam Süre',
      avg: 'Kişi Başı Ortalama',
      logins: 'Toplam Giriş',
      active: 'Aralıkta Aktif Kullanıcı',
    },
    columns: {
      worker: 'Çalışan',
      status: 'Durum',
      range: 'Aralıkta Süre',
      activeDays: 'Aktif Gün',
      dailyAvg: 'Günlük Ort.',
      logins: 'Giriş',
      lastActivity: 'Son Aktivite',
      total: 'Toplam',
    },
    detail: {
      sessions: 'Oturum (aralıkta)',
      totalSessions: 'Toplam Oturum (tüm zamanlar)',
      avgSession: 'Ort. Oturum Süresi',
      lastActivity: 'Son Aktivite',
      daily: 'Günlük Dağılım',
      noDays: 'Seçilen tarih aralığında kayıtlı kullanım süresi yok.',
    },
    dailyChart: 'Ekip Günlük Toplam Süre (saat)',
    perEmployeeChart: 'Çalışan Bazında Toplam Süre (saat)',
    noRecords: 'Seçilen tarih aralığında kayıt yok.',
    hourUnit: ' sa',
    hours: '{{value}} saat',
    dailyTooltip: '{{hours}} saat · {{people}} kişi',
    totalLabel: 'Toplam',
    durationLabel: 'Süre',
    footNote: 'Süreler, kullanıcı sisteme giriş yapmışken sekmenin açık kaldığı zamandan hesaplanır ve güne göre kaydedilir. Açık oturumun son birkaç dakikası henüz günlük toplama yansımamış olabilir. Takip yeni etkinleştirildiği için bu tarihten önceki günlerde kayıt bulunmaz.',
  },

  training: {
    loading: 'Eğitim ve SOP durumu yükleniyor...',
    error: 'Eğitim ve SOP durumu yüklenemedi.',
    allDone: 'Ekipteki herkes kendisine atanan SOP ve eğitimleri tamamlamış.',
    education: 'Eğitim',
    note: 'Atamalar role göre yapılır; çalışanın profilinde tamamladığı kayıtlar burada düşer.',
    noDeadline: 'Son tarih yok',
    overdueBadge_one: '{{count}} gecikmiş',
    overdueBadge_other: '{{count}} gecikmiş',
    tiles: {
      pendingPeople: 'Tamamlamayan Çalışan',
      pendingSops: 'Bekleyen SOP',
      pendingEducations: 'Bekleyen Eğitim',
      overdue: 'Son Tarihi Geçmiş',
    },
    columns: {
      worker: 'Çalışan',
      role: 'Rol',
      pendingSop: 'Bekleyen SOP',
      pendingEducation: 'Bekleyen Eğitim',
      nextDeadline: 'En Yakın Son Tarih',
    },
  },

  documents: {
    title: 'CV / GCP / IATA Belgeleri',
    loading: 'Belgeler yükleniyor...',
    error: 'Belgeler yüklenirken bir hata oluştu.',
    empty: 'Bu çalışanın CV/GCP/IATA belgesi bulunmuyor.',
    missing: 'Eksik zorunlu belge: {{list}}',
    view: 'Görüntüle',
    download: 'İndir',
    help: 'Belgeler Çalışan Yönetimi’ndeki CV/GCP/IATA bölümüyle aynıdır; burada yalnızca görüntüleme ve indirme yapılabilir.',
  },

  leaves: {
    title: 'İzin Detayları',
    year: 'Yıl',
    loading: 'İzinler yükleniyor...',
    error: 'İzin kayıtları yüklenirken bir hata oluştu.',
    hours: '{{hours}} saat',
    balanceTitle: 'Yıllık izin bakiyesi · {{year}}',
    balance: {
      entitlement: 'Toplam hak',
      used: 'Kullanılan',
      reserved: 'Onay bekleyen',
      remaining: 'Kalan',
    },
    timeline: {
      current: 'Şu an izinde',
      last: 'Son izin',
      next: 'Sıradaki izin',
      none: 'Yok',
      until: '{{date}} tarihine kadar',
    },
    frequencyTitle: 'İzin sıklığı · {{year}}',
    frequency: {
      count: 'Onaylı izin',
      countValue_one: '{{count}} kez',
      countValue_other: '{{count}} kez',
      otherStatus: '{{pending}} bekleyen · {{rejected}} reddedilen',
      total: 'Toplam izinli süre',
      gap: 'Ortalama aralık',
      gapValue: '~{{days}} günde bir',
      perMonth: 'Aylık ortalama',
      perMonthValue: 'ayda {{value}} izin',
    },
    monthsTitle: 'Aylara göre (onaylı)',
    monthTitle_one: '{{month}}: {{count}} izin, {{duration}}',
    monthTitle_other: '{{month}}: {{count}} izin, {{duration}}',
    typesTitle: 'İzin türleri',
    typeValue_one: '{{count}} kez · {{duration}}',
    typeValue_other: '{{count}} kez · {{duration}}',
    listTitle_one: 'İzin kayıtları ({{count}})',
    listTitle_other: 'İzin kayıtları ({{count}})',
    filterLabel: 'Durum',
    filter: {
      all: 'Tümü',
      approved: 'Onaylı',
      pending: 'Bekleyen',
      rejected: 'Reddedilen',
    },
    empty: '{{year}} yılında izin kaydı yok.',
    emptyFilter: 'Bu durumda izin kaydı yok.',
    record: {
      ongoing: 'Şu an izinde',
      upcoming: 'Yaklaşan',
      requestedAt: 'Talep / giriş tarihi',
      source: 'Kaynak',
      sourceRequest: 'Çalışanın talebi',
      sourceAdmin: 'İzin Yönetimi’nden eklendi',
      travel: 'Yol süresi',
      approvedBy: 'Onaylayan',
      rejectedBy: 'Reddeden',
      reason: 'İzin nedeni',
      address: 'İzin adresi',
      note: 'Yönetici notu',
      report: 'Belgeyi aç {{name}}',
    },
    help: 'Kayıtlar İzin Yönetimi ile aynıdır; burada yalnızca görüntülenir. Bakiye yalnızca yıllık izni sayar (Cumartesi yarım gün; Pazar ve resmi tatiller sayılmaz), sayımlar iznin başladığı yıla göre yapılır.',
  },

  issueModal: {
    count_one: '{{count}} kayıt',
    count_other: '{{count}} kayıt',
    search: 'Çalışan, proje, kategori veya açıklama ara...',
    empty: 'Gösterilecek kayıt bulunamadı.',
    unknownWorker: 'Bilinmeyen Çalışan',
    noDate: 'Tarih yok',
    patient: 'Hasta: {{id}}',
    category: 'Kaynak / Kategori',
    details: 'Sorun Detayı',
    notes: 'Notlar',
    categories: {
      iv_access: 'IV Erişim',
      patient_compliance: 'Hasta Uyumu',
      documentation: 'Dokümantasyon',
      logistics: 'Lojistik',
      protocol: 'Protokol',
      equipment: 'Ekipman',
      other: 'Diğer',
    },
    flags: {
      issueOccurred: 'Sorun',
      issueResultedInMiss: 'Kaçırılan',
      protocolDeviation: 'Protokol Sapması',
      capaOpened: 'CAPA Açıldı',
      screenFail: 'Tarama Başarısız',
      dropPatient: 'Hasta Çıkışı',
      wasAeSaeTaken: 'AE/SAE',
      dcfCreated: 'DCF',
      overdue: 'SLA Gecikmiş',
    },
  },

  confirm: {
    workerTitle: 'Çalışanı Çıkar',
    smoTitle: 'SMO’yu Kaldır',
    workerMessage: '{{worker}} adlı çalışanı {{smo}} SMO’sundan çıkarmak istediğinize emin misiniz?',
    workerNote: 'Bu işlem, çalışanın bu SMO’ya bağlı merkezlerdeki tüm proje atamalarını kaldırır ve geri alınamaz.',
    smoMessage: '{{smo}} SMO atamasını kaldırmak istediğinize emin misiniz?',
    smoMessage_one: '{{smo}} SMO atamasını {{count}} merkezden kaldırmak istediğinize emin misiniz?',
    smoMessage_other: '{{smo}} SMO atamasını {{count}} merkezden kaldırmak istediğinize emin misiniz?',
    smoNote: 'Merkezler ve çalışan atamaları korunur; yalnızca bu kişinin SMO ataması temizlenir. SMO’yu daha sonra Merkez Yönetimi’nden tekrar atayabilirsiniz.',
    workerAction: 'Çıkar',
    smoAction: 'Kaldır',
    processing: 'İşleniyor...',
    cancel: 'İptal',
  },

  toast: {
    smoListError: 'SMO listesi yüklenirken hata oluştu!',
    workersUpdated: 'Çalışan verileri güncellendi!',
    workersError: 'Çalışan bilgileri yüklenirken hata oluştu!',
    noVisits: 'Bu çalışanın bu projedeki visit’i bulunamadı.',
    excelDownloaded: 'Excel dosyası başarıyla indirildi',
    overviewExcel: 'Operasyonel Özet Excel indirildi',
    qualityExcel: 'Kalite & Risk Excel indirildi',
    performanceExcel: 'Çalışan Performans Excel indirildi',
    noVisitExcel: 'Viziti olmayan çalışanlar raporu indirildi',
    workerRemoved: '{{name}} bu SMO’dan çıkarıldı.',
    workerRemoveError: 'Çalışan çıkarılırken bir hata oluştu!',
    smoRemoved: '{{name}} SMO ataması kaldırıldı.',
    smoRemoved_one: '{{name}} SMO ataması {{count}} merkezden kaldırıldı.',
    smoRemoved_other: '{{name}} SMO ataması {{count}} merkezden kaldırıldı.',
    smoRemoveError: 'SMO kaldırılırken bir hata oluştu!',
  },

  entry: {
    title: 'Manuel Veri Girişi',
    subtitle: 'Vizit Değerlendirme Tablosu',
    help: 'Bir çalışan seçin: mevcut vizitleri hücrelerde düzenleyin, “Yeni Satır Ekle” ile yeni vizit ekleyin. Düzenleme, ekleme ve silmeler “Tümünü Kaydet”e basınca kaydedilir; kaydedilmemiş satırlar “Değişti” / “Yeni” etiketiyle görünür. Sütun başlığındaki büyüteç filtre satırını açar.',
    siteHelp: 'Döngü süresi ve SLA sütunları vizit tarihi, süreç bitiş tarihi ve SLA hedefinden otomatik hesaplanır.',
    tabs: {
      label: 'Vizit türü',
      home: 'Ev Visitleri',
      site: 'Hastane Visitleri',
    },
    worker: 'Çalışan',
    chooseWorker: '-- Çalışan Seçiniz --',
    project: 'Proje',
    allProjects: '-- Tüm Projeler --',
    patient: 'Hasta ID',
    allPatients: '-- Tüm Hastalar --',
    chooseProject: '-- Proje Seçiniz --',
    count_one: '{{count}} kayıt',
    count_other: '{{count}} kayıt',
    countFiltered: '{{shown}} / {{total}} kayıt',
    existingCount_one: '({{count}} mevcut)',
    existingCount_other: '({{count}} mevcut)',
    newCount_one: '({{count}} yeni)',
    newCount_other: '({{count}} yeni)',
    rows_one: '{{count}} satır',
    rows_other: '{{count}} satır',
    rowsFiltered: '{{shown}} / {{total}} satır',
    existingBadge: 'Mevcut: {{count}}',
    newBadge: 'Yeni: {{count}}',
    clearFilters: 'Filtreleri Temizle',
    clearFiltersHint: 'Tüm filtreleri temizle',
    addRow: 'Yeni Satır Ekle',
    loading: 'Vizitler yükleniyor...',
    pickWorker: 'Veri girişi yapmak için bir çalışan seçiniz',
    noHomeVisits: 'Bu çalışana ait vizit bulunamadı. Yeni satır ekleyerek veri girebilirsiniz.',
    noSiteVisits: 'Bu çalışana ait hastane viziti bulunamadı. Yeni satır ekleyerek veri girebilirsiniz.',
    cancel: 'İptal',
    saveAll: 'Tümünü Kaydet',
    saving: 'Kaydediliyor...',
    delete: 'Sil',
    removeRow: 'Satırı sil (Tümünü Kaydet ile silinir)',
    new: 'Yeni',
    existing: 'Mevcut',
    changed: 'Değişti',
    changedBadge: 'Değişen: {{count}}',
    removedBadge: 'Silinecek: {{count}}',
    confirmDelete: {
      title: 'Vizitler silinsin mi?',
      message_one: '{{count}} vizit kalıcı olarak silinecek. Diğer değişiklikler de kaydedilecek.',
      message_other: '{{count}} vizit kalıcı olarak silinecek. Diğer değişiklikler de kaydedilecek.',
      confirm: 'Sil ve Kaydet',
    },
    unsaved: {
      title: 'Kaydedilmemiş değişiklikler',
      message: 'Kaydetmediğiniz düzenlemeler, yeni satırlar veya silmeler var. Devam ederseniz kaybolacak.',
      discard: 'Kaydetmeden Devam Et',
      stay: 'Geri Dön',
    },
    search: 'Ara...',
    filterHint: 'Sütun filtrelerini aç / kapat',
    all: 'Tümü',
    yes: 'Evet',
    no: 'Hayır',
    hours: 'Saat',
    minutes: 'Dakika',
    markNa: 'N/A olarak işaretle',
    groups: {
      identification: 'Kimlik',
      window: 'Pencere / Zamanlama',
      scheduled: 'Planlanan',
      travelBefore: 'Yolculuk (Öncesi)',
      visit: 'Vizit Detayları',
      travelAfter: 'Yolculuk (Sonrası)',
      issue: 'Sorun Bilgisi',
      correction: 'Kalite İncelemesi – Düzeltme Talepleri',
      source: 'Kaynak Döküman Tarihleri',
      outcome: 'Sonuç',
      sourceDocument: 'Kaynak Döküman',
      patientStatus: 'Hasta Durumu',
      siteVisit: 'Vizit',
      protocol: 'Protokol & CAPA',
      completion: 'Tamamlanma Tarihleri',
      sla: 'Süreç & SLA',
      issueShort: 'Sorun',
    },
    home: {
      project: 'Proje',
      patientId: 'Hasta ID',
      visitNumber: 'Vizit ID',
      windowOpen: 'Pencere Açılış',
      targetDate: 'Hedef Tarih',
      windowClose: 'Pencere Kapanış',
      clinician: 'Klinisyen',
      scheduledDate: 'Planlanan Tarih',
      scheduledTime: 'Planlanan Saat',
      startDate: 'Başlangıç Tarihi',
      startTime: 'Başlangıç Saati',
      endDate: 'Bitiş Tarihi',
      endTime: 'Bitiş Saati',
      durationHours: 'Süre (Saat)',
      durationMinutes: 'Süre (Dk)',
      issueOccurred: 'Sorun Oluştu mu?',
      issueResult: 'Sorun Sonucu?',
      issueSource: 'Sorun Kaynağı',
      countryCorrections: 'Ülke Koordinatörleri Düzeltme Talepleri',
      pmCorrections: 'Klinik Proje Yöneticisi Düzeltme Talepleri',
      correctionReason: 'Düzeltme Nedeni / Yorum',
      initialSource: 'İlk Kaynak Tarihi',
      latestRevision: 'Son Revizyon Tarihi',
      sourceFinalized: 'Kaynak Kesinleşme',
      aeSae: 'AE/SAE Gerçekleşti mi?',
      dcf: 'DCF Oluşturuldu mu?',
    },
    site: {
      project: 'Proje Adı',
      center: 'Merkez',
      visitType: 'Visit Tipi',
      sourceDocument: 'Kaynak Döküman',
      sourceDocumentTime: 'Kaynak Döküman Saati',
      visitDate: 'Vizit Tarihi',
      protocolDeviation: 'Protokol Sapması?',
      capaOpened: 'CAPA Açıldı mı?',
      comments: 'Yorumlar',
      ecrfDate: 'eCRF Tamamlanma',
      ecrfTime: 'eCRF Tamamlanma Saati',
      sourceDocDate: 'Kaynak Doküman',
      sourceDocTime: 'Kaynak Doküman Saati',
      signatureDate: 'İmza Tamamlanma',
      processEnd: 'Süreç Bitiş',
      cycleTime: 'Cycle Time (gün)',
      slaTarget: 'SLA Hedef (gün)',
      slaMet: 'SLA Karşılandı mı?',
      slaOverdue: 'SLA Aşıldı mı?',
    },
    toast: {
      loadError: 'Vizitler yüklenirken hata oluştu',
      nothingToSave: 'Kaydedilecek veri bulunamadı',
      pickWorker: 'Önce bir çalışan seçiniz',
      saved_one: '{{count}} kayıt başarıyla kaydedildi',
      saved_other: '{{count}} kayıt başarıyla kaydedildi',
      saveFailed_one: '{{count}} kayıt kaydedilemedi; satırlar ekranda duruyor, tekrar kaydedin',
      saveFailed_other: '{{count}} kayıt kaydedilemedi; satırlar ekranda duruyor, tekrar kaydedin',
      saveError: 'Kaydetme sırasında hata oluştu',
      noChanges: 'Kaydedilecek değişiklik yok',
      duplicate: 'Bu vizit tabloda zaten var: {{patient}} / {{visit}}. Yinelenen satırı silin veya Vizit ID’yi düzeltin.',
    },
  },
};

export default smoLead;
